// Registration statuses returned by the JOT partner API on `partner_status`.
// Keep this in sync with jot-frontend/src/page/ApplyExam/partnerStatus.ts
export const PARTNER_STATUS_MAP = {
  pending_review: {
    label: "Pending Review",
    sentence: "The registration has been sent to JOT and is waiting to be reviewed.",
    tone: "warning",
  },
  accepted_for_review: {
    label: "Accepted for Review",
    sentence: "JOT has accepted the registration and is currently reviewing it.",
    tone: "warning",
  },
  approved: {
    label: "Approved",
    sentence: "JOT has approved the registration. The exam seat will be confirmed shortly.",
    tone: "info",
  },
  registered: {
    label: "Registered",
    sentence: "The candidate is successfully registered for the exam with JOT.",
    tone: "success",
  },
  rejected: {
    label: "Rejected",
    sentence: "JOT rejected this registration. Please review the submitted details and re-apply.",
    tone: "danger",
  },
  failed: {
    label: "Failed",
    sentence: "The registration could not be completed at JOT. Refresh the status or re-submit.",
    tone: "danger",
  },
  conflict: {
    label: "Conflict",
    sentence: "A conflicting registration already exists at JOT for this candidate and exam.",
    tone: "warning",
  },
};

const normalise = (status) => String(status || "").trim().toLowerCase();

export const getPartnerStatus = (status) =>
  PARTNER_STATUS_MAP[normalise(status)] || {
    label: status
      ? String(status).replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
      : "Not Submitted",
    sentence: status
      ? "This registration status was not recognised. Refresh the status to get the latest from JOT."
      : "This application has not been submitted to JOT yet.",
    tone: "secondary",
  };

export const getPartnerStatusLabel = (status) => getPartnerStatus(status).label;
export const getPartnerStatusSentence = (status) => getPartnerStatus(status).sentence;
export const getPartnerStatusTone = (status) => getPartnerStatus(status).tone;
